import { Box, Divider, ListItem, Typography } from "@mui/material";
import { FC } from "react";

interface MarathonListItemProps {
  key?: string;
  label: string;
  value: React.ReactNode;
  isConditionMet?: boolean;
  maxWidth?: number;
}

export const MarathonListItem: FC<MarathonListItemProps> = ({ key, label, value, isConditionMet = true, maxWidth }) => {
  return (
    <ListItem style={{ padding: "8px 0" }}>
      <Box display="flex" justifyContent="space-between" width="100%" overflow="hidden" key={key}>
        <Typography variant="body2" sx={{ fontWeight: "500", fontSize: "15px", lineHeight: "24px", color: "#3E444A" }}>{label}</Typography>
        <Divider sx={{ flexGrow: 1, height: "1px", my: 2 }} />
        <Typography sx={{ fontWeight: "500", fontSize: "14px", lineHeight: "22.4px", color: "#3E444A", wordBreak: 'break-word', maxWidth: maxWidth + 'px' || '170px' }} variant="body2">{value}</Typography>
      </Box>
    </ListItem>
  );
};
